class DetectLanguage {

  getLanguage() {

    const path = window.location.pathname;

    if (path.startsWith('/uk')) {
      return 'ua';
    }

    if (path.startsWith('/ru')) {
      return 'ru';
    }

  }
}

export {DetectLanguage};